module.exports = __webpack_public_path__ + "static/media/left.30c17983.svg";